import { render, staticRenderFns } from "./LangChange.vue?vue&type=template&id=16219222&"
import script from "./LangChange.vue?vue&type=script&lang=js&"
export * from "./LangChange.vue?vue&type=script&lang=js&"
import style0 from "./LangChange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports